import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
//import NewVenue from 'components/AddNewVenue/AddNewVenue';
import NewVenueV2 from 'components/AddNewVenue/AddNewVenueV2';
import axios from 'axios';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import { organization_user_access_level, user_access_level, owner_perms, org_friendly_url, apiUrl, myHeaders_Autorized, events_list_api, myHeaders_With_Cache_Control, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , HeaderConfig, venues_api, user_entity_uuid,
import '../style.css';
// import PKButton from "components/Button/Button";
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { local_routes } from 'utils/Routes';
// import { NavLink } from 'react-router-dom';
import { GoogleApiWrapper } from 'google-maps-react';

import UserContext from 'store/UserContext';

let imgTempArr = [];

class Venue extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props)
        this.state = {
            use_zoom_venue: true,
            event_admin_flag: false,
            source_owner: false,
            venues_array: [],
            selected_venue_index: 0,
            loading: true,
            message: '',
            error_message: '',
            
            /*
            venueValidate: false,
            loading: true,
            showComponent: false,
            venueData: [],
            venue_uuid: null,
            // FormData
            placeName: '',
            validated: false,
            street: '',
            city: '',
            state: '',
            postal: '',
            phone: '',
            website: '',
            ticketSite: '',
            capacity: '',
            // Image data
            imgArr: [],
            locationId: '',
            venue_name: null,
            nextBtnLoader: false,
            createVenueLoader: false,
            totalVenData: null,
            initialVenueName: null,
            initialVenueId: null,
            successFormData: 0,
            locationData:null,
            */
        };
        //this.onClickToggleAddUser = this.onClickToggleAddUser.bind(this);
        //this.onClickFromRmUser = this.onClickFromRmUser.bind(this);
        
        //this.back_to_list = false;
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }

    }

    APICalls = async function (config) {
        let new_state = {...this.state}
        
        if (!this.props.event_uuid) {
            console.error("BAD! No event_uuid");
            return;
        }
        
        if (!this.props.source_info.entity_type || !this.props.source_info.entity_uuid) {
            console.error("BAD! No source_info",this.props.source_info);
            return;
        }
        
        if (user_access_level === 'admin') {
            new_state.source_owner = true;
        }
        
        let api_promises = [];
        if (this.props.source_info.entity_type === 'locations') {
            api_promises.push(axios.get(`${apiUrl}locations/${this.props.source_info.entity_uuid}/venues`, myHeaders_With_Cache_Control));
            if (owner_perms && owner_perms['locations'] && owner_perms['locations'][this.props.source_info.entity_uuid] && owner_perms['locations'][this.props.source_info.entity_uuid] === 'admin') {
                new_state.source_owner = true;
            }
        } else if (this.props.source_info.entity_type === 'channels') {
            /*
            api_promises.push(axios.get(`${apiUrl}channels/${this.props.source_info.entity_uuid}/venues`, myHeaders_With_Cache_Control));
            if (owner_perms && owner_perms['channels'] && owner_perms['channels'][this.props.source_info.entity_uuid] && owner_perms['channels'][this.props.source_info.entity_uuid] === 'admin') {
                new_state.source_owner = true;
            }
            */
            
            // are we channel_admin or admin?
            if (user_access_level === 'channel_admin' || user_access_level === 'admin') {
                api_promises.push(axios.get(`${apiUrl}channels/${this.props.source_info.entity_uuid}/venues`, myHeaders_With_Cache_Control));
                if (owner_perms && owner_perms['channels'] && owner_perms['channels'][this.props.source_info.entity_uuid] && owner_perms['channels'][this.props.source_info.entity_uuid] === 'admin') {
                    new_state.source_owner = true;
                }
            } else {
                // then we are normal user editing a one-off event that we own; either show create venue or edit venue, but not the list
                /*
                let params = {
                    filter_obj: {
                        entity_owner_integer: {
                            gte: 1
                        }
                    }
                };
                api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/venues`, { params, ...myHeaders_With_Cache_Control }));
                */
                if (config.selected_venue_uuid) {
                    // edit
                    api_promises.push(axios.get(`${apiUrl}venues/${config.selected_venue_uuid}`, myHeaders_With_Cache_Control ));
                } else {
                    // add
                }
                new_state.event_admin_flag = true;
                new_state.showEditComponent = true;
            }
            
        } else if (this.props.source_info.entity_type === 'organizations') {
            api_promises.push(axios.get(`${apiUrl}organizations/${this.props.source_info.entity_uuid}/venues`, myHeaders_With_Cache_Control));
            if (organization_user_access_level === 'admin') {
                new_state.source_owner = true;
            }
        }    
        let [source_venues_response] = await Promise.all(api_promises);

        if (source_venues_response && source_venues_response.data) {
            if (new_state.event_admin_flag) {
                new_state.venues_array = [source_venues_response.data];
                new_state.venues_array = new_state.venues_array.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
            } else {
                new_state.venues_array = source_venues_response.data;
                new_state.venues_array = new_state.venues_array.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
            }
        }
        new_state.venues_array.unshift({entity_uuid:'',entity_name:'(None)'});
        
        if (config.selected_venue_uuid) {
            // a little tricky because of sorting by name
            for (let i = 0; i < new_state.venues_array.length; i++) {
                if (new_state.venues_array[i].entity_uuid === config.selected_venue_uuid) {
                    new_state.selected_venue_index = i;
                }
            }
        } else {
            new_state.selected_venue_index = 0;
        }
        
        if (config.message) {
            new_state.message = config.message;
        } else {
            new_state.message = "";
        }
        if (config.error_message) {
            new_state.error_message = config.error_message;
        } else {
            new_state.error_message = "";
        }
        new_state.loading = false;
        
        if (new_state.selected_venue_index || !this.props.event_info.zoom_webinar_id) {
            new_state.use_zoom_venue = false;
        }
        
        this.setState( new_state );

        /*
        new_state.venueData = source_venues_response.data.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
        new_state.venueData.unshift({entity_name:'(None)',entity_uuid:''})
        */
        
        if (this.props.event_info.venues && this.props.event_info.venues.length > 0) {
            
            //new_state.initialVenueName = this.props.event_info.venues[0].entity_name;
            //new_state.venue_name = this.props.event_info.venues[0].entity_name;
            //new_state.initialVenueId = this.props.event_info.venues[0].entity_uuid;
            //new_state.venue_uuid = this.props.event_info.venues[0].entity_uuid;
        } else {
            //new_state.initialVenueName = '(None)';
            //new_state.initialVenueId = '';
            //new_state.venue_name = '';
            //new_state.venue_uuid = '';
        }
        
        new_state.loading = false;
        
        this.setState(new_state);        
        
    }

    componentDidMount = async function () {
        //window.scrollTo(0, 0)
        //console.log(this.props)
        //const { match: { params: { event_uuid } = {} } = {} } = this.props;
        
        // do we already have a venue?
        let selected_venue_uuid = '';
        if (this.props.event_info.venues && this.props.event_info.venues.length > 0) {
            selected_venue_uuid = this.props.event_info.venues[0].entity_uuid;
        }
        
        await this.APICalls({selected_venue_uuid});
    }

    onSaveVenue = async (venue_info) => {
        if (venue_info === false) {
            // cancel
            this.setState({
                message: '',
                error_message: 'Canceled',
                selected_venue_index: 0,
                showEditComponent: false
            });
            return;
        }
        
        this.setState({
            loading: true,
            showEditComponent: false
        });
        
        let message = "";
        let error_message = "";
        
        let tmp_venue_info = {...venue_info};
        tmp_venue_info.friendly_url = tmp_venue_info.entity_name.toLowerCase().replace(/ /g, "-");

        // if we have entity_uuid it would be blank...remove it
        delete tmp_venue_info.entity_uuid;
        
        if (venue_info.entity_uuid) {
            // EDIT / patch
            await axios.patch(`${apiUrl}venues/${venue_info.entity_uuid}`, tmp_venue_info);
            // bust cache
            if (this.props.event_info.status_code === 1) {
              axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}/venues`,myHeaders_Auth_With_Cache_Control);
            }
            message = "Venue successfully edited";
        } else {
            // CREATE / post
            if (this.props.source_info.entity_type === 'locations') {
                tmp_venue_info.locations = [{
                    entity_uuid: this.props.source_info.entity_uuid
                }];
            }
            if (this.props.source_info.entity_type === 'channels') {
                if (!this.state.event_admin_flag) {
                    tmp_venue_info.channels = [{
                        entity_uuid: this.props.source_info.entity_uuid
                    }];
                }
            }
            // also associate with event right now, instead of waiting for somebody to click "next"
            tmp_venue_info.events = [{
                entity_uuid: this.props.event_uuid 
            }];
            
            let add_venue_response = await axios.post(`${apiUrl}venues`, tmp_venue_info);
            // bust cache
            if (this.props.event_info.status_code === 1) {
              axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}/venues`,myHeaders_Auth_With_Cache_Control);
            }

            if (add_venue_response.data.entity_uuid) {
                venue_info.entity_uuid = add_venue_response.data.entity_uuid;
                message = "Venue successfully added";
            } else {
                // problem!
                venue_info.entity_uuid = "";
                error_message = "Problem adding venue";
            }
        }
        
        this.APICalls({message,selected_venue_uuid:venue_info.entity_uuid});
        //this.APICalls({message,error_message});
    }

    // Onclick navigate to next step
    nextStep = async () => {
        
        //console.log("ManageEvent Venue nextStep",this.props);
        if (this.state.use_zoom_venue) {
            if (this.props.event_info.venues && this.props.event_info.venues.length > 0) {
                // remove old venue xref
                await axios.delete(`${apiUrl}events/${this.props.event_uuid}/venues/${this.props.event_info.venues[0].entity_uuid}`);
                // bust cache
                await axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}/venues`,myHeaders_Auth_With_Cache_Control);
            }
            let next_page = `${this.workspace_base_url}${local_routes.manageevent}/${this.props.event_uuid}/presenters`;
            if (this.back_to_list) {
                if (this.props.source_info.referrer) {
                    next_page = this.props.source_info.referrer;
                } else {
                    next_page = `${this.workspace_base_url}${local_routes.myevents}`;
                }
            }
            this.props.history.push(next_page);
            return;
        }
        
        if (!this.state.venues_array[this.state.selected_venue_index].entity_uuid) {
            //this.setState({ venueValidate: true, validated: false });
            this.setState({
                error_message: 'Please Select a Venue',
                message: ''
            })
            return;
        }
        
        let venue_uuid = this.state.venues_array[this.state.selected_venue_index].entity_uuid;

        // Condition check to remove existing venue if already there for this event.
        if (this.props.event_info.venues && this.props.event_info.venues.length > 0) {
            let initial_venue_uuid = this.props.event_info.venues[0].entity_uuid;
            let deleVenRes = await axios.delete(`${events_list_api}/${this.props.event_uuid}/venues/${initial_venue_uuid}`, myHeaders_Autorized)
            if (deleVenRes !== null && deleVenRes !== undefined) {
                await axios.patch(`${events_list_api}/${this.props.event_uuid}`, { venues: [{ entity_uuid: venue_uuid }] }, myHeaders_Autorized);
                // break cache
                if (this.props.event_info.status_code === 1) {
                    await axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}/venues`,myHeaders_Auth_With_Cache_Control);
                }
                //this.props.history.push(`${this.workspace_base_url}${local_routes.manageevent}/${this.props.event_uuid}/presenters`)
                //this.props.next();
            
            }
        } else {
            //console.log("ManageEvent Venue nextStep 2",this.props.event_uuid);
            //return;
            await axios.patch(`${events_list_api}/${this.props.event_uuid}`, { venues: [{ entity_uuid: venue_uuid }] }, myHeaders_Autorized);
            // break cache
            if (this.props.event_info.status_code === 1) {
                await axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}/venues`,myHeaders_Auth_With_Cache_Control);
            }
            //this.props.history.push(`${this.workspace_base_url}${local_routes.manageevent}/${this.props.event_uuid}/presenters`)
            //this.props.next();
        }
    
        let next_page = `${this.workspace_base_url}${local_routes.manageevent}/${this.props.event_uuid}/presenters`;
        if (this.back_to_list) {
            if (this.props.source_info.referrer) {
                next_page = this.props.source_info.referrer;
            } else {
                next_page = `${this.workspace_base_url}${local_routes.myevents}`;
            }
        }
    
        this.props.history.push(next_page);
    }
    

    saveThenBack = async () => {
        console.log("saveThenBack");
        this.back_to_list = true;
        this.nextStep();
    }

    prevScreen = () => {
        //const { match: { params: { event_uuid } = {} } = {} } = this.props;
        this.props.history.push(`${this.workspace_base_url}${local_routes.manageevent}/${this.props.event_uuid}/description`)
        //this.props.prev();
    }

    // For handling venue change
    venueChangeHandler = (event) => {
        console.log("Manage Event venueChangeHandler",event.target.value);
        this.setState({
            message: '',
            //showEditComponent: (event.target.value !== '0'), // '(None)'
            selected_venue_index: parseInt(event.target.value)
        });
    }
    
    onClickShowAddVenue = () => {
        this.setState({
            message: '',
            error_message: '',
            showEditComponent: true,
            selected_venue_index: 0 // blank info except entity_name
        });
    }

    handleCancel = async () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }
    
    onZoomVenueChange = (use_zoom_venue) => {
        this.setState({
            use_zoom_venue
        })
    }

    render() {
        //const { venueData, loading, showComponent, venue_name, nextBtnLoader, locationData } = this.state;
        //console.log("locationData",locationData)
        if (this.state.loading) {
            return (
                <div className="spinner-pos">
                    <FullPageSpinner />
                </div>
            )
        }

            return (
                <div className="venue eventCreation">
                    { this.props.event_info.zoom_webinar_id &&
                        <ToggleButtonGroup
                          //style={{ height: "80%" }}
                          size="sm"
                          type="radio"
                          name="use_zoom_venue"
                          //name="venue_type"
                          value={this.state.use_zoom_venue}
                          onChange={this.onZoomVenueChange}
                        >
                          <ToggleButton
                            size="sm"
                            variant={this.context.theme === 'dark' ? "outline-light" : "outline-dark"}
                            //variant="outline-dark"
                            style={{ textTransform: 'none', whiteSpace: "nowrap" }}
                            
                            //name="venue_type"
                            value={true}
                            //disabled={!entity_info.publishable}
                          >
                            { this.state.use_zoom_venue ? 'Using Connected Zoom for Venue' : 'Use Connected Zoom for Venue'}
                          </ToggleButton>
                          <ToggleButton
                            size="sm"
                            variant={this.context.theme === 'dark' ? "outline-light" : "outline-dark"}
                            //variant="outline-dark"
                            style={{ textTransform: 'none', whiteSpace: "nowrap" }}
                            //style={{ whiteSpace: "nowrap" }}
                            
                            //name="venue_type"
                            value={false}
                            //disabled={!entity_info.publishable}
                            
                          >
                            { this.state.use_zoom_venue ? 'Use Custom Venue' : 'Using Custom Venue'}
                          </ToggleButton>
                        </ToggleButtonGroup>                    
                    }

                    <div className="form-group btn-venueposition">
                        <Button style={{ marginRight: "5px" }} size="sm" variant="secondary" onClick={this.prevScreen}>Previous</Button>
                        <Button style={{ marginRight: "5px" }} size="sm" variant="secondary" onClick={this.handleCancel}>Cancel</Button>
                        <Button style={{ marginRight: "5px" }} size="sm" variant="pkprimary" onClick={this.saveThenBack}>Save</Button>
                        <Button size="sm" variant="pkprimary" onClick={this.nextStep}>Save + Next</Button>
                        {/*
                        <Button theme="btn btn-draft" OnClickMet={() => this.prevScreen()}>Previous</Button>
                        <button className="btn btn-draft" onClick={() => this.handleCancel()}>Cancel</button>
                        <Button style={{marginRight: "6px"}} theme="btn btn-next" OnClickMet={() => this.saveThenBack()}>Save</Button>
                        <Button theme="btn btn-next" OnClickMet={() => this.nextStep()}>Save + Next</Button>
                        */}
                    </div>

                    { !this.state.use_zoom_venue &&
                        <React.Fragment>
                        {/* <Form onSubmit={this.handleSubmitDescriptionData}> */}
                        { (!this.state.event_admin_flag && (!this.state.showEditComponent || (this.state.showEditComponent && this.state.selected_venue_index !== 0))) &&
                            <Form.Row className="align-items-center">
                                <Form.Group as={Col} md="6" controlId="validationPkTitle" className="venueAlign" style={{marginTop: "20px"}}>
                                    <span className="d-flex justify-content-between align-items-center">
                                        <Form.Label>Select Existing Venue</Form.Label>
                                    </span>
                                    <Form.Control
                                        disabled={this.state.showEditComponent}
                                        as="select"
                                        //required
                                        //value={this.state.venues_array[this.state.selected_venue_index].entity_name}
                                        value={this.state.selected_venue_index}
                                        onChange={this.venueChangeHandler}
                                    >
                                        {
                                            this.state.venues_array.map((item,i) =>
                                                <option key={item.entity_uuid} value={i}>{item.entity_name}</option>
                                            )
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>
                        }

    
                        { this.state.message &&
                            <p style={{color:'green',fontSize:12}}>{this.state.message}</p>
                        }
                        { this.state.error_message &&
                            <p style={{color:'red',fontSize:12}}>{this.state.error_message}</p>
                        }
                        { (!this.state.showEditComponent && (this.state.source_owner || this.state.event_admin_flag)) &&
                            <h6 onClick={this.onClickShowAddVenue}>+ Add New Venue</h6>
                        }
                        
                        {/* </Form> */}
                        { this.state.showEditComponent &&
                            <div style={{ paddingTop: "10px" }}>
    
                                    <NewVenueV2
                                        venue_info={this.state.venues_array[this.state.selected_venue_index]}
                                        onSaveVenue={this.onSaveVenue}
                                    />
    
                                
                            </div>
                        }
                        </React.Fragment>
                    }
                </div>
            );

    }
}

//export default withRouter(Venue);

export default withRouter(
    GoogleApiWrapper({
        apiKey: 'AIzaSyATS36RdvbWd9ESucCYIVvzqIxj3EFbQcg'
    }) (Venue)
);
